import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 20 20'
    width={size || width}
    height={size || height}
    {...props}
  >
    <mask
      id='prefix__a'
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill='currentColor' d='M0 0h20v20H0z' />
    </mask>
    <g mask='url(#prefix__a)'>
      <path
        fill='currentColor'
        d='m17.25 18.141-2.667-2.666v2.15h-1.25v-4.291h4.292v1.25h-2.171l2.666 2.666zM10 17.917a7.7 7.7 0 0 1-3.088-.623A8 8 0 0 1 4.4 15.602a8 8 0 0 1-1.692-2.514 7.7 7.7 0 0 1-.624-3.086q0-1.643.624-3.088A8 8 0 0 1 4.399 4.4a8 8 0 0 1 2.513-1.693 7.7 7.7 0 0 1 3.087-.623 7.7 7.7 0 0 1 3.087.623q1.446.624 2.514 1.692a8 8 0 0 1 1.693 2.514q.624 1.445.624 3.087a8 8 0 0 1-.143 1.507H16.49A6.7 6.7 0 0 0 16.667 10q0-.454-.06-.908a6 6 0 0 0-.189-.903H13.32q.079.45.114.903a12 12 0 0 1 .01 1.661q-.025.376-.076.754h-1.25a11.4 11.4 0 0 0 .066-2.415 10 10 0 0 0-.113-.903H7.929q-.078.449-.113.904a12 12 0 0 0 0 1.816q.035.453.113.902h3.064v1.25H8.217q.277.983.716 1.887A9.3 9.3 0 0 0 10 16.649q.377 0 .753-.044.377-.044.753-.086v1.268q-.376.041-.753.086-.376.045-.753.044M3.582 11.81H6.68a10 10 0 0 1-.114-.903 12 12 0 0 1 0-1.817q.034-.453.114-.902H3.582q-.129.449-.189.904a7 7 0 0 0 0 1.816 6 6 0 0 0 .189.902m.524-4.872h2.823q.215-.907.573-1.754a9.2 9.2 0 0 1 .884-1.62A6.1 6.1 0 0 0 5.871 4.76a6.46 6.46 0 0 0-1.765 2.18m4.28 9.497a11 11 0 0 1-.864-1.628 12 12 0 0 1-.59-1.747H4.107a6.5 6.5 0 0 0 1.769 2.172q1.117.884 2.511 1.203m-.17-9.497h3.568a10 10 0 0 0-.717-1.878q-.45-.894-1.067-1.71a10 10 0 0 0-1.07 1.701 10.3 10.3 0 0 0-.714 1.887m4.851 0h2.827a6.5 6.5 0 0 0-1.765-2.183 6 6 0 0 0-2.515-1.192q.503.78.852 1.632.35.853.601 1.743'
      />
    </g>
  </svg>
)
export default SvgComponent
